import React, { Component } from 'react';
import 'typeface-lato';
import 'typeface-montserrat';
import Navigation from './components/Navigation';
import Router from './components/Router';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import Logo from './components/Logo';
import './style.css';
import './style-resp.css';

class App extends Component {

  render() {
    return (
      <div className="App">
        <Navigation />
        <Logo />
        <Router />
        <Sidebar />
        <Footer />
      </div>
    );
  }

  // SET CSS VARIABLES
  setCssVar() {
    root.style.setProperty('--screenWidth', (window.innerWidth - 0) +"px");
    root.style.setProperty('--screenWidthMinusSidebar', (window.innerWidth - 350) +"px");
    root.style.setProperty('--screenHeight', (window.innerHeight - 0) +"px");
  }

  // PARALLAX FUNCTION FOR SPECIFIC OBJECT
  parallax(pObject) {
    let scrolled = document.documentElement.scrollTop;
    let increment = 0.2;
    if (pObject != null) {
      pObject.style.setProperty('-ms-transform', 'translate(0px, ' + Math.round((scrolled*increment)) +'px)');
  	  pObject.style.setProperty('-webkit-transform', 'translate(0px, ' + Math.round((scrolled*increment)) +'px)');
      pObject.style.setProperty('transform', 'translate(0px, ' + Math.round((scrolled*increment)) +'px)');
    }
  }

  // EXECUTE ON SCROLL EVENT
  scrolling() {
    //this.parallax(document.getElementById('featuredImage'));
    //this.parallax(document.getElementById('mainLogo'));
  }

  // RESET PRELOAD AFTER MAIN LOADING
  resetPreloadTime() {
    setTimeout(() => {
     root.style.setProperty('--preloadTime', 0+"s");
    }, 4000);
  }

  componentDidMount() {
    this.setCssVar();
    this.resetPreloadTime();
    window.addEventListener("resize", this.setCssVar.bind());
    window.addEventListener("scroll", this.scrolling.bind(this));
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js